import { SimpleTableBase } from '@core/components/Table';
import { TableActionButton, TableActionContainer } from '@core/components/TableAction';
import { useReduxLoading, useReduxMessage } from '@core/hooks';
import moment from 'moment';
import React from 'react';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { HistoricoRemessaActions } from './store';
import { useHistoricoRemessa } from './store/historicoRemessaContext';

const HistoricoRemessaTable = ({ contaInit }) => {
  const [state, dispatch] = useHistoricoRemessa();
  const { message, page, carregandoRegistros } = state;

  useReduxLoading(carregandoRegistros);

  useReduxMessage(message);

  const onFetchData = async (params) => {
    const params2 = {
      ...params,
      contaId: contaInit?.id,
    };

    HistoricoRemessaActions.carregarRegistros(dispatch, params2);
  };

  const handleBaixarArquivoRemessa = (historico) => {
    HistoricoRemessaActions.baixarArquivoRemessa(dispatch, historico?.uuidArquivo, historico?.arquivoRemessa);
  };

  const onSortingChange = (params) => {
    dispatch(HistoricoRemessaActions.setSorting(params));
  };

  const onCurrentPageChange = (params) => {
    dispatch(HistoricoRemessaActions.setCurrentPage(params));
  };

  const onPageSizeChange = (params) => dispatch(HistoricoRemessaActions.setPageSize(params));

  const columns = [
    {
      name: 'sequencial',
      title: 'Sequencial de remessa',
      sortingEnabled: true,
      getCellValue: (historico) => historico?.sequencial?.toString().padStart(6, '0'),
    },
    {
      name: 'arquivoRemessa',
      title: 'Arquivo remessa',
      sortingEnabled: false,
    },
    {
      name: 'vencimentosBoletos',
      title: 'Data do vencimento',
      sortingEnabled: false,
    },
    {
      name: 'dataHoraRegistro',
      title: 'Data do arquivo',
      sortingEnabled: true,
      getCellValue: (historico) =>
        historico?.dataHoraRegistro && moment(historico?.dataHoraRegistro).format('DD/MM/YYYY'),
      align: 'center',
    },
    {
      name: 'contaDescricao',
      title: 'Conta bancária',
      sortingEnabled: false,
      getCellValue: (historico) => historico?.contaDescricao,
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      getCellValue: (historico) => (
        <TableActionContainer>
          <TableActionButton
            title="Baixar arquivo remessa"
            icon={<FaCloudDownloadAlt size={10} />}
            onClick={() => handleBaixarArquivoRemessa(historico)}
          />
        </TableActionContainer>
      ),
      width: 120,
    },
  ];

  return (
    <SimpleTableBase
      fetchOnCreate
      defaultSorting={[{ columnName: 'sequencial', direction: 'asc' }]}
      columns={columns}
      rows={page.content.map((a) => ({ ...a, id: a.uuidArquivo }))}
      loading={carregandoRegistros}
      totalCount={page.content?.length}
      searchBy={state.requestParams?.q}
      fetchData={onFetchData}
      onCurrentPageChange={onCurrentPageChange}
      onPageSizeChange={onPageSizeChange}
      onSortingChange={onSortingChange}
      hideSelection
    />
  );
};

export default HistoricoRemessaTable;
